import { getSubjectBounds, maskHasTransparentPixels } from "../../utils/getBoundingBox";
import { ALPHA_HIT_THRESHOLD } from "./subjectHitTest";

  export function tightenLockedSubject(layout) {
    const mask = layout.alphaMaskRef.current;
    if (!mask || layout.alphaMaskFallbackRef.current) return false;
    if (!maskHasTransparentPixels(mask, ALPHA_HIT_THRESHOLD)) return false;

    const bounds = getSubjectBounds(mask, 0.9);
    if (
      !bounds ||
      bounds.width <= 0 ||
      bounds.height <= 0 ||
      bounds.width * bounds.height >= mask.width * mask.height * 0.97
    ) {
      return false;
    }

    const orig = layout.originalImageSizeRef.current;
    const baseline = layout.layoutLockFullObjectRef.current;
    const lockedObj = baseline
      ? { width: baseline.width, height: baseline.height }
      : layout.objectSizeRef.current;
    const lockedPos = baseline
      ? { x: baseline.x, y: baseline.y }
      : layout.objectPositionRef.current;
    const baseW = baseline?.imageW || orig.width;
    const baseH = baseline?.imageH || orig.height;
    if (!baseW || !baseH || !lockedObj.width || !lockedObj.height) {
      return false;
    }

    const sx = lockedObj.width / baseW;
    const sy = lockedObj.height / baseH;
    const nextCrop = {
      x: bounds.left,
      y: bounds.top,
      width: bounds.width,
      height: bounds.height,
    };
    const nextObjectSize = {
      width: bounds.width * sx,
      height: bounds.height * sy,
    };
    const nextObjectPosition = {
      x: lockedPos.x + bounds.left * sx,
      y: lockedPos.y + bounds.top * sy,
    };

    layout.cropStateRef.current = nextCrop;
    layout.cropExtentRef.current = { ...nextCrop };
    layout.objectSizeRef.current = nextObjectSize;
    layout.objectPositionRef.current = nextObjectPosition;
    layout.objectTightBoundsRef.current = true;
    layout.setCropState(nextCrop);
    layout.setObjectSize(nextObjectSize);
    layout.setObjectPosition(nextObjectPosition);
    return true;
  };

